export const CHECK_IN = "Check-in";
export const CHECK_OUT = "Check-out";
export const SELECT_DATES = "Select dates for";
